import { getIsOdd } from '../common/validators';
import { createEditableContent, createReadOnlyContent } from './templates';
import { shouldSkipRendering } from './utils';

const renderDescription = ({ task, column, t, onlyRead }) => {
  const gantt = window.ganttVisualization;
  const columnName = column.name;
  const isOnlyReadElement = onlyRead || task.readonly;

  if (shouldSkipRendering(task, gantt)) {
    return '';
  }

  const isOdd = getIsOdd({ gantt, task }, columnName);
  const content = isOnlyReadElement
    ? createReadOnlyContent(task, column, t)
    : createEditableContent(task, columnName, t, column);

  return `
    <div class="${isOdd ? 'odd-col' : 'non-odd-col'}">
      <span class="vertical-center">
        ${content}
      </span>
    </div>
  `;
};

export default renderDescription;
